import {hookFormDate, hookFormDropdownValue, hookIntToBool} from "root/Base/HookFormComponents/hookFormValidation";

const convertGender = (genderString) =>
{
    switch (genderString)
    {
        case 'M' :
            return 1;
        case 'F' :
            return 2;
        case 'N' :
            return 3;
        case 'O' :
            return 4;
        default :
            return null;
    }
}

export const formModes = {
    VIEW: 0,
    CREATE: 1,
    EDIT: 2
}

export const childHeader = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            header:
                {
                    firstname: null,
                    middlename: null,
                    surname: null,
                    esw_name: null,
                    esw_email: null,
                    child_upn: null,
                    ics_ref: null,
                    gender: null,
                    gender_detail: null,
                    date_of_birth: null,
                    date_became_lac: null,
                    date_last_became_lac: null,
                    year_id: null,
                    is_held_back: false,
                }
        }
    }
    else
    {
        const esw_name = child.esw === undefined ? '' : child.esw.firstname + ' ' + child.esw.surname;
        return {
            header:
                {
                    firstname: child.firstname,
                    middlename: child.middlename,
                    surname: child.surname,
                    esw_name: esw_name,
                    esw_email: child.esw?.email === undefined ? null : child.esw?.email,
                    child_upn: child.child_upn,
                    ics_ref: child.ics_ref,
                    gender: hookFormDropdownValue(convertGender(child.gender)),
                    gender_detail: child.gender_detail,
                    date_of_birth: hookFormDate(child.dmy_date_of_birth, 'dd/MM/yyyy'),
                    date_became_lac: hookFormDate(child.dmy_date_became_lac, 'dd/MM/yyyy'),
                    date_last_became_lac: hookFormDate(child.dmy_date_last_became_lac, 'dd/MM/yyyy'),
                    year_id: hookFormDropdownValue(child.year_id),
                    is_held_back: hookIntToBool(child.is_held_back),
                }
        }

    }
}

export const childEAL = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            eal: {
                ethnicity: null,
                asylum_status: false,
                eal_flag: false,
                country_id: null,
                first_language: null,
                preferred_language: null
            }
        }
    }
    else
    {
        return {
            eal: {
                ethnicity: hookFormDropdownValue(child.ethnicity),
                asylum_status: +(child.asylum_status) !== 0,
                eal_flag: hookIntToBool(child.eal_flag),
                country_id: hookFormDropdownValue(child.country_id),
                first_language: child.first_language,
                preferred_language: child.preferred_language
            }
        }
    }
}

export const childPPP = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            pp_plus:
                {
                    pp_plus: false
                },
        }
    }
    else
    {
        return {
            pp_plus:
                {
                    pp_plus: hookIntToBool(child.ppplus_flag)
                },
        }
    }
}

const isSenK = (child) =>
{
    if (child.needs === null || child.needs === undefined || child.length === 0)
    {
        if (+child.sen_k_flag === 1)
        {
            return true;
        }
    }

    return false;
}

const isSEN = (child) =>
{
    if (child.needs === null || child.needs === undefined || child.length === 0)
    {
        return false
    }
    else
    {
        return true;
    }
}

export const childSEN = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            sen:
                {
                    sen_k_flag: false,
                    senk_details: false,
                    ehcp_flag: false,
                    needs: null,
                    provision: null,
                    dmy_last_review_date: null,
                    dmy_statement_date: null,
                    ehcp_la_code: null
                },
        }
    }
    else
    {
        return {
            sen:
                {
                    sen_k_flag: isSenK(child),
                    ehcp_flag: isSEN(child),
                    needs: child.needs?.needs === undefined ? null : child.needs?.needs,
                    senk_details: child.senk_details ,
                    provision: child.needs?.provision === undefined ? null : child.needs?.provision,
                    dmy_last_review_date: hookFormDate(child.needs?.dmy_last_review_date, 'dd/MM/yyyy'),
                    dmy_statement_date: hookFormDate(child.needs?.dmy_statement_date, 'dd/MM/yyyy'),
                    ehcp_la_code: hookFormDropdownValue(child.ehcp_la_code)
                },
        }
    }
}

export const childStatutory = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            statutory:
                {
                    statutory_referral_flag: false,
                    dmy_statutory_referral_date: null,
                    dmy_sr_proposed_end_date: null,
                },
        }
    }
    else
    {
        return {
            statutory:
                {
                    statutory_referral_flag: hookIntToBool(child.statutory_referral_flag),
                    dmy_statutory_referral_date: hookFormDate(child.dmy_statutory_referral_date, 'dd/MM/yyyy'),
                    dmy_sr_proposed_end_date: hookFormDate(child.dmy_sr_proposed_end_date, 'dd/MM/yyyy'),
                },
        }
    }
}

export const childPost16 = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            post16:
                {
                    education_status_id: null,
                    care_leaver_flag: false,
                    pep_opt_out_flag: false,
                    pep_opt_out_reason: null,
                },
        }
    }
    else
    {
        // Special case as we need to include es_type in the value
        const esValue = child.education_status_id === null ? null : { value: +(child.education_status_id), es_type: +(child.es_type) }

        return {
            post16:
                {
                    education_status_id: esValue,
                    care_leaver_flag: hookIntToBool(child.care_leaver_flag),
                    pep_opt_out_flag: hookIntToBool(child.pep_opt_out_flag),
                    pep_opt_out_reason: child.pep_opt_out_reason,
                },
        }
    }
}

export const childRiskOfExclusion = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            risk_of_exclusion:
                {
                    risk_of_exclusion_flag: false,
                    dmy_risk_of_exclusion_date: null,
                },
        }
    }
    else
    {
        return {
            risk_of_exclusion:
                {
                    risk_of_exclusion_flag: hookIntToBool(child.risk_of_exclusion_flag),
                    dmy_risk_of_exclusion_date: hookFormDate(child.dmy_risk_of_exclusion_date, 'dd/MM/yyyy'),
                },
        }
    }
}

export const childTransitioning = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            transition:
                {
                    is_transitioning: false,
                    transition_id: null,
                },
        }

    }
    else
    {
        return {
            transition:
                {
                    is_transitioning: child.transition_id !== null,
                    transition_id: hookFormDropdownValue(child.transition_id),
                },
        }

    }
}

export const childFullTimeEducation = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            full_time_education:
                {
                    full_time_education_flag: true,
                    alternate_provision: null,
                    alternate_provision_notes: null,
                    alternate_provision_reason: null,
                    ap_reason_id: null,
                    alternate_provision_hours: null,
                    alternate_provision_start_date: null,
                    alternate_provision_agreement_date: null,
                },
        }
    }
    else
    {
        const isInFullTimeEducationFlag = hookIntToBool(child.full_time_education_flag);

        return {
            full_time_education:
                {
                    full_time_education_flag: isInFullTimeEducationFlag,
                    alternate_provision: !isInFullTimeEducationFlag ? child.alternate_provision : null,
                    alternate_provision_notes: !isInFullTimeEducationFlag ? child.alternate_provision_notes : null,
                    alternate_provision_reason: !isInFullTimeEducationFlag ? child.alternate_provision_reason : null,
                    ap_reason_id: !isInFullTimeEducationFlag ? hookFormDropdownValue(child.ap_reason_id) : null,
                    alternate_provision_hours: !isInFullTimeEducationFlag ? child.alternate_provision_hours : null,
                    alternate_provision_start_date: hookFormDate(child.dmy_alternate_provision_start_date, 'dd/MM/yyyy'),
                    alternate_provision_agreement_date: hookFormDate(child.dmy_alternate_provision_agreement_date, 'dd/MM/yyyy'),
                },
        }

    }
}

export const childReducedTimetable = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            reduced_timetable:
                {
                    ap_pt_flag: false,
                    dmy_ap_pt_start_date: null,
                    ap_pt_hours: null,
                    ap_pt_reason: null
                },
        }
    }
    else
    {
        return {
            reduced_timetable:
                {
                    ap_pt_flag: hookIntToBool(child.ap_pt_flag),
                    dmy_ap_pt_start_date: hookFormDate(child.dmy_ap_pt_start_date, 'dd/MM/yyyy'),
                    ap_pt_hours: child.ap_pt_hours,
                    ap_pt_reason: child.ap_pt_reason
                },
        }

    }
}

export const childStarFunding = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            star_funding:
                {
                    top_up_funding_flag: false,
                    funding_start_date: null,
                    funding_end_date: null,
                },
        }
    }
    else
    {
        return {
            star_funding:
                {
                    top_up_funding_flag: +(child.top_up_funding_flag) !== 0,
                    funding_start_date: hookFormDate(child.dmy_funding_start_date, 'dd/MM/yyyy'),
                    funding_end_date: hookFormDate(child.dmy_funding_end_date, 'dd/MM/yyyy'),
                },
        }
    }
}

export const childBursary = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            bursary:
                {
                    has_bursary: false,
                    bursary_notes: null,
                },
        }
    }
    else
    {
        return {
            bursary:
                {
                    has_bursary: child.bursary === 'Y',
                    bursary_notes: child.bursary_notes,
                },
        }
    }
}

export const childEETBursary = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            eet_bursary:
                {
                    has_bursary_in_place: false,
                    bursary_notes: null,
                    bursary_progress: null,
                },
        }
    }
    else
    {
        return {
            eet_bursary:
                {
                    has_bursary_in_place: +child.has_bursary_in_place === 1,
                    bursary_notes: child.bursary_notes,
                    bursary_progress: child.bursary_progress,
                },
        }
    }
}

export const childEmployment = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            employment:
                {
                    has_cv: false,
                    cv_comments: null,
                    has_skills: null,
                    neet_comments: null,
                },
        }
    }
    else
    {
        return {
            employment:
                {
                    has_cv: +child.has_cv === 1,
                    cv_comments: child.cv_comments,
                    has_skills: +child.has_skills === 1,
                    neet_comments: child.neet_comments,
                },
        }
    }
}

export const childCarer = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            carer:
                {
                    carer_id: null,
                    date_care_started: null,
                },
        }
    }
    else
    {
        return {
            carer:
                {
                    carer_id: null,
                    date_care_started: null,
                },
        }
    }
}

export const childSocialWorker = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            social_worker:
                {
                    social_worker_id: null,
                    date_sw_started: null,
                },
        }
    }
    else
    {
        return {
            social_worker:
                {
                    social_worker_id: null,
                    date_sw_started: null,
                },
        }
    }
}

export const childIRO = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            iro:
                {
                    iro_id: null,
                },
        }
    }
    else
    {
        return {
            iro:
                {
                    iro_id: null,
                },
        }
    }
}

export const childESW = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            esw:
                {
                    esw_id: null,
                },
        }
    }
    else
    {
        return {
            esw:
                {
                    esw_id: null,
                },
        }
    }
}

export const childEdPsych = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            ed_psych:
                {
                    ed_psych_id: null,
                },
        }
    }
    else
    {
        return {
            ed_psych:
                {
                    ed_psych_id: null,
                },
        }
    }
}

export const childSchool = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            school:
                {
                    school_id: null,
                    teacher_id: null,
                    date_setting_started: null,
                },
        }
    }
    else
    {
        return {
            school:
                {
                    school_id: null,
                    teacher_id: null,
                    date_setting_started: null,
                },
        }
    }
}

export const childYear4Multiplication = (child) =>
{
    if (child === null || child === undefined || child.length === 0)
    {
        return {
            year4_multiplication:
                {
                    year_4_multiplication_score: null,
                    year_4_multiplication_exempt: false,
                    year_4_multiplication_comment: null,
                },
        }
    }
    else
    {
        return {
            year4_multiplication:
                {
                    year_4_multiplication_score: child.year_4_multiplication_score,
                    year_4_multiplication_exempt: +child.year_4_multiplication_exempt === 1,
                    year_4_multiplication_comment: child.year_4_multiplication_comment,
                },
        }
    }
}

export const enteringCareHookFormDesc = (ecare) =>
{
    if (ecare === null || ecare === undefined || ecare.length === 0)
    {
        return {
            entering_care:
                {
                    school_name: null,
                    age: null,
                    year_1_phonics_score: null,
                    carer: null,
                    carer_address: null,
                    current_attendance: null,
                    last_two_terms_attendance: null,
                    fixed_term_exclusions: null,
                    early_years_achievement: null,
                    ks1_achievement: null,
                    ks2_achievement: null,
                    ks3_achievement: null,
                    age_related_curriculum: null,
                    attitude_to_homework: null,
                    last_two_term_progress: null,
                    reading_age: null,
                    date_of_reading_assessment: null,
                    sdq_result: null,
                    date_of_sdq_assessment: null,
                    excluded_prior_to_care: null,
                    exclusion_date: null,
                },
        }
    }
    else
    {
        return {
            entering_care:
                {
                    school_name: ecare.school_name,
                    age: ecare.age,
                    year_1_phonics_score: ecare.year_1_phonics_score,
                    carer: ecare.carer,
                    carer_address: ecare.carer_address,
                    current_attendance: ecare.current_attendance,
                    last_two_terms_attendance: ecare.last_two_terms_attendance,
                    fixed_term_exclusions: ecare.fixed_term_exclusions,
                    early_years_achievement: hookFormDropdownValue( ecare.early_years_achievement ),
                    ks1_achievement: hookFormDropdownValue( ecare.ks1_achievement ),
                    ks2_achievement: hookFormDropdownValue( ecare.ks2_achievement ),
                    ks3_achievement: hookFormDropdownValue( ecare.ks3_achievement ),
                    age_related_curriculum: hookFormDropdownValue( ecare.age_related_curriculum ),
                    attitude_to_homework: hookFormDropdownValue( ecare.attitude_to_homework ),
                    last_two_term_progress: hookFormDropdownValue( ecare.last_two_term_progress ),
                    reading_age: ecare.reading_age,
                    date_of_reading_assessment: hookFormDate(ecare.date_of_reading_assessment, 'dd/MM/yyyy' ),
                    sdq_result: ecare.sdq_result,
                    date_of_sdq_assessment: hookFormDate(ecare.date_of_sdq_assessment, 'dd/MM/yyyy' ),
                    excluded_prior_to_care: hookFormDropdownValue( ecare.excluded_prior_to_care ),
                    exclusion_date: hookFormDate(ecare.exclusion_date, 'dd/MM/yyyy' ),
                },
        }
    }
}